import kamala from '../../kamala'
import Dropdown from './Dropdown'
import DropdownMenu from './DropdownMenu'
import DropdownItem from './DropdownItem'
import TriggerIndicator from './TriggerIndicator'

const KDropdownFamily = {
  install: function (Vue) {
    kamala(Vue)

    Vue.component(Dropdown.name, Dropdown)
    Vue.component(DropdownMenu.name, DropdownMenu)
    Vue.component(DropdownItem.name, DropdownItem)
    Vue.component(TriggerIndicator.name, TriggerIndicator)
  },
  KDropdown: Dropdown,
  KDropdownMenu: DropdownMenu,
  KDropdownItem: DropdownItem,
  KTriggerIndicator: TriggerIndicator,
}

export default KDropdownFamily
